export default __webpack_public_path__ + "static/media/logo_horizontal_svg.edf85f86.svg";